import React from "react";
import FeatureCard from "./FeatureCard";

function FeaturesSection() {
  return (
    <div className="relative z-10">
      <section
        id="features"
        className="relative py-16 md:py-24 z-0 bg-black"
        style={{ marginTop: "-70px", paddingTop: "100px" }}
      >
        <div
          className="absolute inset-0 z-0"
          style={{
            background: "radial-gradient(circle at 50% 50%, rgba(157, 78, 221, 0.1) 0%, rgba(0, 0, 0, 0) 70%)",
          }}
        ></div>
        <div className="container relative z-10 mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-white">
              Private, Secure, Decentralized
            </h2>
            <p className="mt-4 text-lg text-gray-400 max-w-2xl mx-auto">
              Meet other traders in an environment that puts privacy and security first
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <FeatureCard
              icon="shield"
              title="Scam-Proof Chat"
              description="Anti-phishing link detection prevents scams from reaching you. All links are automatically disabled to protect your assets."
            />
            <FeatureCard
              icon="users"
              title="Verified Top Traders"
              description="Connect with verified high-performing Solana traders based on real on-chain activity and performance metrics."
            />
            <FeatureCard
              icon="zap"
              title="Privacy First"
              description="Your wallet activity stays private. Only you decide what to share, while our leaderboard tracks public performance."
            />
            <FeatureCard
              icon="rocket"
              title="Learn From The Best"
              description="Discover successful trading strategies directly from proven traders through secure, private communications."
            />
          </div>
        </div>
      </section>
    </div>
  );
}

export default FeaturesSection;